var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebtokooIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 5.5,
    r: 5,
    fill: "#F2A42C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.83 8.51002L14.28 3.27002C13 2.25002 11 2.24002 9.72996 3.26002L3.17996 8.51002C2.23996 9.26002 1.66996 10.76 1.86996 11.94L3.12996 19.48C3.41996 21.17 4.98996 22.5 6.69996 22.5H17.3C18.99 22.5 20.59 21.14 20.88 19.47L22.14 11.93C22.32 10.76 21.75 9.26002 20.83 8.51002ZM12.75 18.5C12.75 18.91 12.41 19.25 12 19.25C11.59 19.25 11.25 18.91 11.25 18.5V15.5C11.25 15.09 11.59 14.75 12 14.75C12.41 14.75 12.75 15.09 12.75 15.5V18.5Z",
    fill: "#E95440"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebtokooIcon);
export default __webpack_public_path__ + "static/media/webtokoo-icon.793ee3708d4e47a02f45a2c696a44929.svg";
export { ForwardRef as ReactComponent };